export default "__VITE_ASSET__BaMJDnWn__"